import { useEffect, useState } from "react";

// Mounted only in the authenticated view; plant membership is not public metadata.
export function TwinPlant({ twinId, revision }) {
  const [plant, setPlant] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    setPlant(null);
    if (twinId) fetch(`/api/my/twins/${encodeURIComponent(twinId)}/plant`, { signal: controller.signal, cache: "no-store" })
      .then(response => response.ok ? response.json() : null)
      .then(value => { if (!controller.signal.aborted) setPlant(value); })
      .catch(() => {});
    return () => controller.abort();
  }, [twinId, revision]);
  if (!plant) return null;
  return <div className="chain-notice"><b>PLANT · {plant.name}</b><span>{plant.tenantId ? `Tenant: ${plant.tenantId}` : "Personal plant · no organizational tenant"} · {plant.visibility === "public" ? "Public map listing" : "Private"} · stored on Integration Server</span></div>;
}
